import { render, staticRenderFns } from "./skxRzsx.vue?vue&type=template&id=5a6a2672&scoped=true&"
import script from "./skxRzsx.vue?vue&type=script&lang=js&"
export * from "./skxRzsx.vue?vue&type=script&lang=js&"
import style0 from "./skxRzsx.vue?vue&type=style&index=0&id=5a6a2672&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6a2672",
  null
  
)

export default component.exports